<template>
  <div class="liveWrap">
    <main :class="bgColor ? 'mainBgWhite' : 'mainBgBlack'" style="padding:0">
      <div class="videoWrap">
        <div class="videoBox">
          <div class="topWrap">
           {{ kejian_title }}
          </div>
          <video v-if="!isAliyun" :src="srcs" controls="controls" id="offcnplayer" />
          <div v-show="isAliyun" id="aliplayer-con" class="aliplayer-container"></div>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import Header from "./components/header.vue";
import { previewvideo,toKey } from "./assets/api.js";
import {getCookie} from "@/assets/js/cookie.js";
import { loadAliplayer } from "@/utils/aliplayerLoader";

export default {
  components: { Header},
  data() {
    return {
      bgColor: true,
      srcs:{},
      kejian_title:'',
      // 阿里云视频点播相关
      isAliyun: false,
      aliPlayer: null,
    };
  },
  mounted() {
    const params={
      sid:getCookie('sid'),
      sket:getCookie('sket')
    }
    toKey(params).then((res) => {
      if (res.code == 0) {
        this.getinfos();
      }
    });

  },
  beforeDestroy() {
    this.disposeAliplayer();
  },
  methods: {
    getinfos() {
      let params = {
        video_id: this.$route.query.id,
      };
      previewvideo(params).then((res) => {
        if (res.code == 0) {
          this.kejian_title = res.data.video.title;
          // 阿里云视频点播：使用 Aliplayer VOD 模式播放
          if (res.data.video.is_aliyun == "1") {
            this.initAliplayer(res.data.video);
          } else {
            // 原有 m3u8 视频：HLS.js 播放
            this.isAliyun = false;
            this.disposeAliplayer();
            this.$nextTick(() => {
              var video = document.getElementById("offcnplayer");
              if (!video) return;
              var hls = new Hls();
              hls.loadSource(
                      res.data.video.host + res.data.video.m3u8url,
                      encodeURIComponent(res.data.video.m3u8)
              );
              hls.attachMedia(video);
            });
          }
        }
      });
    },
    // 初始化阿里云 Aliplayer
    // 优先：URL 模式（后端 GetPlayInfo 返回 play_url，直接播放）
    // 降级：VOD 模式（vid + playAuth，由 Aliplayer SDK 调用阿里云 API 获取地址）
    initAliplayer(video) {
      this.isAliyun = true;
      this.disposeAliplayer();
      this.$nextTick(() => {
        loadAliplayer().then((Aliplayer) => {
          const cover = video.cover_url || "";
          var playerConfig = {
            id: "aliplayer-con",
            width: "100%",
            height: "100%",
            autoplay: false,
            isLive: false,
            cover: cover,
            playsinline: true,
            controlBarVisibility: "hover"
          };
          // HLS 加密视频：无论 URL 模式还是 VOD 模式，都需设置 encryptType=1
          if (video.is_encrypted == "1" || video.is_encrypted == 1) {
            playerConfig.encryptType = 1;
          }
          if (video.play_url) {
            // URL 模式：直接使用后端返回的播放地址
            playerConfig.source = video.play_url;
          } else {
            // VOD 模式：使用 vid + playAuth
            playerConfig.vid = video.aliyun_video_id;
            playerConfig.playauth = video.play_auth;
          }
          this.aliPlayer = new Aliplayer(playerConfig, function (player) {
            // ready
          });
        }).catch((e) => {
          this.$message.error(e.message || "Aliplayer 加载失败");
        });
      });
    },
    // 销毁 Aliplayer 实例
    disposeAliplayer() {
      if (this.aliPlayer) {
        try { this.aliPlayer.dispose(); } catch (e) {}
        this.aliPlayer = null;
      }
    },
  },

};

</script>

<style scoped lang="scss">
  @import "./assets/video.scss";
  #offcnplayer{ position: absolute}
  .aliplayer-container{ width:100%; height:100%; position:absolute; }
  .colorBlue {
    color: #507fff;
  }
  .colorGreen {
    color: #42c9ab;
  }
  .colorRed {
    color: #fe4d67;
  }
  .liveWrap main .videoWrap .videoBox{ padding-bottom: 0 !important;}
</style>
